import { getRoute } from 'pmt-modules/routing'

import DevThemePage from '../../../dev/pages/theme'
import StyleguidePage from '../../../dev/pages/styleguide'
import TestPage from '../../../dev/pages/test'

export default [
  {
    definition: getRoute('DEV_THEME'),
    handler: DevThemePage,
  },
  {
    definition: getRoute('DEV_STYLEGUIDE'),
    handler: StyleguidePage,
  },
  {
    definition: getRoute('DEV_TEST'),
    handler: TestPage,
  },
]
